import Modal from '../../../components/common/Modal';

export default function OpeningBalanceStatusModal({
  mode,
  open,
  busy,
  onClose,
  onConfirm,
}) {
  if (!open) return null;

  const isLock = mode === 'lock';
  const title = isLock ? 'Lock Opening Balance' : 'Unlock Opening Balance';
  const body = isLock
    ? 'Opening balance must be balanced before locking. After locking, setup stays read-only until you unlock it again.'
    : 'Unlocking opening balance will allow editing again for this financial year.';
  const confirmLabel = isLock ? 'Lock OB' : 'Unlock OB';
  const confirmClass = isLock ? 'btn btn-success' : 'btn btn-danger';

  return (
    <Modal
      title={title}
      onClose={busy ? () => {} : onClose}
      actions={(
        <>
          <button className="btn btn-secondary" onClick={onClose} disabled={busy}>Cancel</button>
          <button className={confirmClass} onClick={onConfirm} disabled={busy}>
            {busy ? `${confirmLabel}...` : confirmLabel}
          </button>
        </>
      )}
      size="sm"
    >
      <div className="modal-body">
        <p style={{ margin: 0 }}>{body}</p>
      </div>
    </Modal>
  );
}
